/**
 * Data-responsibility identities for the legal pages (LGPD/GDPR).
 * See docs/DATA_RESPONSIBILITY.md.
 *
 * The OPERATOR (platform owner/licensee) is the data CONTROLLER. TruSOM (the
 * PROVIDER) is the data PROCESSOR only when it hosts the platform, and merely
 * the software developer when the operator self-hosts. These values are read
 * from the environment so changing the owner is a config change, not a code
 * change. Unset values fall back to generic wording.
 */

const env = process.env;

export const OPERATOR = {
  /** Razão social da Operadora (Controladora). Fallback genérico se não configurado. */
  name: env.REACT_APP_OPERATOR_NAME || "a Operadora (licenciada da plataforma)",
  cnpj: env.REACT_APP_OPERATOR_CNPJ || "",
  dpoEmail: env.REACT_APP_OPERATOR_DPO_EMAIL || "",
  /** true quando a identidade da Operadora foi de fato configurada. */
  get isConfigured() {
    return Boolean(env.REACT_APP_OPERATOR_NAME);
  },
};

export const PROVIDER = {
  /** Fornecedora do software (TruSOM). */
  name:
    env.REACT_APP_PROVIDER_NAME ||
    "TruSOM - True Software and Marketing Innovation",
  cnpj: env.REACT_APP_PROVIDER_CNPJ || "28.994.111/0001-80",
  dpoEmail: env.REACT_APP_PROVIDER_DPO_EMAIL || "dpo@trusom.com",
};

/** "trusom" = TruSOM hospeda (é processadora) · "self" = operadora auto-hospeda (TruSOM só desenvolve). */
export const HOSTING_MODE = (env.REACT_APP_HOSTING_MODE || "trusom") as
  | "trusom"
  | "self";

export const isTrusomHosted = HOSTING_MODE === "trusom";

/**
 * Frase pronta sobre o papel da TruSOM conforme a hospedagem — para inserir
 * nas políticas/termos.
 */
export const providerRoleSentence = isTrusomHosted
  ? `${PROVIDER.name} (CNPJ ${PROVIDER.cnpj}) atua como Operadora de dados (processadora), tratando os dados exclusivamente por instrução da Controladora para hospedar e operar a tecnologia.`
  : `${PROVIDER.name} (CNPJ ${PROVIDER.cnpj}) atua exclusivamente como fornecedora do software (desenvolvedora); a plataforma é hospedada pela própria Controladora, que responde pela infraestrutura e pelo tratamento dos dados.`;

/** Texto curto que identifica a Controladora (com CNPJ quando configurado). */
export const controllerLine = OPERATOR.isConfigured
  ? `${OPERATOR.name}${OPERATOR.cnpj ? ` (CNPJ ${OPERATOR.cnpj})` : ""}`
  : OPERATOR.name;
